import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {City} from './cities';
import {TreeNode} from "primeng/api";

@Injectable()
export class CityService {

    constructor(private http: Http) {

    }

    getAll(page: number = 1, sort: string = '') {
        let currentfilter = JSON.parse(localStorage.getItem('filter'));
        if (!currentfilter) {
            currentfilter = {};
        }

        const params = new URLSearchParams();
        params.set('page', page + '');
        params.set('sorts', sort);
        for (let key in currentfilter) {
            if (currentfilter[key]) {
                params.set('filter[' + key + ']', currentfilter[key])
            }
        }
        return this.http.get('cities?' + params.toString()).map((response: Response) => response.json());
    }

    getAllCities() {
        return this.http.get('cities/all').map((response: Response) => response.json());
    }
    getById(_id: string) {
        return this.http.get('cities/' + _id).map((response: Response) => response.json());
    }

    getTree(_id:string) {
      return this.http.get('cities/tree/' + _id).toPromise().then(res => <TreeNode[]> res.json());
    }

    getTrashedById(_id: string) {
        return this.http.get('cities/trashed/' + _id).map((response: Response) => response.json());
    }

    restoreTrashedById(_id: string) {
        return this.http.put('cities/trashed/' + _id, {}).map((response: Response) => response.json());
    }

    create(city: City) {
        return this.http.post('cities', city).map((response: Response) => response.json());
    }

    update(city: City) {
        return this.http.put('cities/' + city.id, city).map((response: Response) => response.json());
    }

    delete(_id: string) {
        return this.http.delete('cities/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/cities/cities.service.ts